import React, { useRef, useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import './Toast.css';
import Card from './../Card/Card';
import ToastSnippet from '../../snippets/ToastSnippet/ToastSnippet.js';
import { Copy } from 'lucide-react';

const Toast = () => {
  useEffect(() => {

  }, []);
  const snippetContainerRef = useRef(null);
  const [showScanning, setShowScanning] = useState(false);

  // ✅ OPEN Universal Toast
  const openToast = (e) => {
    const toastId = e.currentTarget.dataset.toast;
    const toast = document.getElementById(toastId);
    if (!toast) return;

    toast.classList.add("seek");

    // start closing animation
    setTimeout(() => {
      toast.classList.add("toast-cl");
    }, 3900);

    // fully hide toast
    setTimeout(() => {
      toast.classList.remove("toast-cl", "seek");
    }, 4000);
  };


  const copySnippet = () => {
    if (snippetContainerRef.current) {
      const range = document.createRange();
      range.selectNode(snippetContainerRef.current);
      window.getSelection().removeAllRanges();
      window.getSelection().addRange(range);
      document.execCommand('copy');
      window.getSelection().removeAllRanges();

      setShowScanning(true);
      setTimeout(() => setShowScanning(false), 1000);
    }
  };
  return (
    <motion.div
      initial={{ y: 10, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      exit={{ y: -10, opacity: 0 }}
      transition={{ duration: 0.2 }}
    >
      <div className='d-flex g-3'>
        <button
          className="carve-button-main"
          data-toast="toastDefault"
          onClick={openToast}
        >
          Open toast
        </button>

        <div className="carve-toast" id="toastDefault">
          Lorem ipsum dolor sit amet consectetur adipisicing elit. Nihil, delectus soluta? Veritatis quae voluptas id illo officiis? Cupiditate, consequatur voluptas.
        </div>

        <button
          className="carve-button-stroke stroke-main"
          data-toast="toastRed"
          onClick={openToast}
        >
          Open red toast
        </button>

        <div className="carve-toast red-toast" id="toastRed">
          Lorem ipsum dolor sit amet consectetur adipisicing elit. Nihil, delectus soluta? Veritatis quae voluptas id illo officiis? Cupiditate, consequatur voluptas.Lorem ipsum dolor sit amet consectetur adipisicing elit. Nihil, delectus soluta? Veritatis quae voluptas id illo officiis? Cupiditate, consequatur voluptas.
        </div>
        <button
          className="carve-button-vice"
          data-toast="toastGreen"
          onClick={openToast}
        >
          Open green toast
        </button>

        <div className="carve-toast green-toast" id="toastGreen">
          Lorem ipsum dolor sit amet consectetur adipisicing elit. Nihil, delectus soluta? Veritatis quae voluptas id
        </div>

      </div>

      <div className={`center-container ${showScanning ? 'scanning' : ''}`}>

        <div className='snippet' ref={snippetContainerRef}>
          <ToastSnippet />
        </div>
        <button aria-label="Copy Button" onClick={copySnippet}>
          <Copy />
        </button>

      </div>
    </motion.div>
  );
}

const ToastsCard = () => {
  return (
    <Card
      CardTitle='Toast'
      CardBody={<Toast />}
    />
  );
}

export default ToastsCard;